import { ChatHistoryListPage } from './ChatHistoryListPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/admin/internal-tools/chat-history/')({
  component: ChatHistoryListPage,
});
